import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthStateService } from '../services/MemberServices/LoginAndAuth/auth-state.service';

export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const u = req.url.toLowerCase();

  // Do NOT attach member token to admin APIs
  if (u.includes('/adminauth/') || u.includes('/adminprofile/') || u.includes('/admin/')) {
    return next(req);
  }

  // Do NOT attach member token to OTP endpoints
  if (u.includes('/api/otp/')) {
    return next(req);
  }

  const token = localStorage.getItem('auth_token');
  const authedReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  const auth = inject(AuthStateService);
  const router = inject(Router);

  return next(authedReq).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        // Token expired or invalid — clear everything and redirect to login
        // clearAuth(false) skips the page reload so router.navigate works cleanly
        auth.clearAuth(false);
        localStorage.removeItem('auth_token');
        localStorage.removeItem('AuthenticatedEmail');
        localStorage.removeItem('AuthenticatedCNIC');
        localStorage.removeItem('SelectedMemberID');
        localStorage.removeItem('member_profile');
        localStorage.removeItem('__membership_context');
        router.navigate(['/member/login']);
      }
      return throwError(() => err);
    })
  );
};